<template>
  <div>
    <div v-if="loading" >
    <b-skeleton class="skeleton-input"></b-skeleton>
    <b-skeleton class="skeleton-label"></b-skeleton>
    </div>
    <div v-else class="validate-patient">
      <label class="cpf-field-label"><span style="color: #f04f50">*</span>CPF do paciente</label>
      <input
        type="tel"
        class="form-control input-validate"
        :class="{ 'invalid-value-input': errorMessage,
                  'input-filled': (!!cx_patientDocument && cx_patientDocument.length > 0) }"
        inputmode="numeric"
        placeholder="Dígitos do CPF"
        v-mask="'###.###.###-##'"
        v-model="cx_patientDocument"
      />
      <div v-if="errorMessage" class="cpfIsInvalid">
        <b-icon icon="x-circle" class="icon-error" aria-hidden="true"></b-icon>
        <span>{{ errorMessage }}</span>
      </div>
      <span v-else-if="cx_patientDocument.length < 14" class="input-text cpf-message">
        O CPF será utilizado apenas para identificar o paciente no agendamento. Pacientes sem CPF devem agendar o serviço na clínica.
      </span>
      <div v-if="!errorMessage && cx_patientDocument.length === 14" class="cpfIsValid">
        <b-icon icon="check-circle" class="icon-check" aria-hidden="true"></b-icon>
        <span>CPF válido. Continue para finalizar o agendamento.</span>
      </div>
    </div>
  </div>
</template>
<script>
import ValidatePatient from "@/components/Patient/ValidatePatient/ValidatePatient.ts";
export default ValidatePatient;
</script>

<style lang="scss" scoped>
@import "ValidatePatient.scss";
</style>
